import { useTranslation } from "@opendash/i18n";
import { Button, Flex, Form, Typography } from "antd";
import React from "react";
import OperationItem from "./OperationItem";

export default () => {
  const t = useTranslation();

  return (
    <div style={{ marginBottom: 24 }}>
      <Typography.Text style={{ paddingBottom: 8, display: "block" }}>
        {t("openware:parse.form.operation.label")}
      </Typography.Text>
      <Form.List name="operations">
        {(fields, operation, meta) => {
          return (
            <Flex gap={16} vertical justify="center">
              {fields.map((field) => (
                <OperationItem
                  key={field.key}
                  index={field.name}
                  onDelete={() => operation.remove(field.name)}
                />
              ))}
              <Button onClick={() => operation.add()} type="dashed">
                {t("openware:parse.form.operation.add.label")}
              </Button>
            </Flex>
          );
        }}
      </Form.List>
    </div>
  );
};
